<template>
  <div style="margin-top: 4px;">
    <div
      style="cursor: pointer; font-size: 12px; color: #666; user-select: none; display: inline-flex; align-items: center; gap: 4px;"
      @click="expanded = !expanded"
    >
      <span>{{ expanded ? '▾' : '▸' }}</span>
      <span>{{ title }} <span style="color: #999;">{{ expanded ? '(click or drag to insert)' : '(click to expand)' }}</span></span>
    </div>
    <div v-if="expanded" style="margin-top: 6px; display: flex; flex-wrap: wrap; gap: 6px;">
      <span
        v-for="(field, index) in visibleFields"
        :key="field.name"
        :id="`pfs-chip-${_uid}-${index}`"
        draggable="true"
        class="pfs-field-chip"
        @click="insertField(field.name)"
        @dragstart="onDragStart($event, field.name)"
      >{{ field.name }}<b-tooltip :target="`pfs-chip-${_uid}-${index}`" triggers="hover" placement="top">{{ field.description }}</b-tooltip></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PfsFieldHelp',
  props: {
    fields: {
      type: Array,
      required: true,
    },
    editorRef: {
      default: null,
    },
    title: {
      type: String,
      default: 'Available Fields',
    },
    // Tenant type ('TBN' / 'CM') of the tenant currently being configured.
    // Fields flagged with `only` are hidden unless they match this. Omit
    // (or leave null) to show every field, e.g. for tenant-agnostic contexts.
    tenantType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(function(field) {
        return !field.only || field.only === this.tenantType
      }, this)
    },
  },
  methods: {
    _resolveEditor() {
      // Prefer the live prop if it resolved correctly
      if (this.editorRef && typeof this.editorRef.insertToken === 'function') {
        return this.editorRef
      }
      // $refs aren't reactive in Vue 2 — the prop is often undefined at first
      // render. Find the sibling PfsRichEditor by looking for .pfs-rich-editor
      // in the same parent container and resolving its Vue instance.
      var container = this.$el && this.$el.parentNode
      if (!container) return null
      var editorEl = container.querySelector('.pfs-rich-editor')
      if (editorEl && editorEl.__vue__) {
        return editorEl.__vue__
      }
      return null
    },
    insertField(fieldName) {
      var editor = this._resolveEditor()
      if (editor) {
        editor.insertToken('[' + fieldName + ']')
      }
    },
    onDragStart(e, fieldName) {
      // Dismiss any open tooltip so it doesn't hang over the editor during drag
      this.$root.$emit('bv::hide::tooltip')
      e.dataTransfer.effectAllowed = 'copy'
      e.dataTransfer.setData('application/x-pfs-token', '[' + fieldName + ']')

      // Build a ghost image identical to the internal-chip drag: the chip clone
      // sits inside a div with transparent padding below it so the cursor hotspot
      // lands in the padding, keeping the chip above the cursor while dragging.
      var target = e.currentTarget
      var gap = 28
      var ghost = document.createElement('div')
      ghost.style.cssText = 'position:fixed;top:-9999px;left:-9999px;padding-bottom:' + gap + 'px;'
      ghost.appendChild(target.cloneNode(true))
      document.body.appendChild(ghost)
      var hotX = Math.round(target.offsetWidth / 2)
      var hotY = target.offsetHeight + Math.round(gap / 2)
      e.dataTransfer.setDragImage(ghost, hotX, hotY)
      setTimeout(function() { document.body.removeChild(ghost) }, 0)
    },
  },
}
</script>

<style scoped>
/* chip styles moved out of inline (and out of js hover handlers) so theme css can override them */
.pfs-field-chip {
  display: inline-block;
  padding: 2px 8px;
  background: #e8f0fe;
  border: 1px solid #c5d5f7;
  border-radius: 12px;
  font-family: monospace;
  font-size: 12px;
  cursor: grab;
  color: #1a56db;
  transition: background 0.15s;
}
.pfs-field-chip:hover {
  background: #c5d5f7;
}
</style>
